export const PORTFOLIO = 'portfolio';
export const WATCHLIST = 'watchlist';
export const EXTERNAL_ACCOUNT = 'externalAccount';

export type PortfolioType = typeof PORTFOLIO | typeof WATCHLIST;
